export default __webpack_public_path__ + "static/media/고블렛잔 만들기 클래스_웹.2068d0ea.jpg";